export default {
  SET_AVAILABILITIES: 'SET_AVAILABILITIES',
  CLEAR_AVAILABILITIES_BY_TYPE: 'CLEAR_AVAILABILITIES_BY_TYPE',
  SET_DETAILPAGE_URL: 'SET_DETAILPAGE_URL',
  ADD_DETAIL_DATASHEETS: 'ADD_DETAIL_DATASHEETS',
  CLEAR_DETAIL_DATASHEETS: 'CLEAR_DETAIL_DATASHEETS',
  // SET_CATALOGTREEPAGE_URL: 'SET_CATALOGTREEPAGE_URL',
  SET_CATALOGTREE_PATH: 'SET_CATALOGTREE_PATH', // ToDo: Remove
  SET_CATALOGTAB_ID: 'SET_CATALOGTAB_ID', // ToDo: Remove
  SET_PRODUCTS_REQUEST_PARAMS: 'SET_PRODUCTS_REQUEST_PARAMS',
  SET_PRODUCT_REQUEST_PARAMS: 'SET_PRODUCT_REQUEST_PARAMS',
  ADD_QUICKBUY_ITEMS: 'ADD_QUICKBUY_ITEMS',
  MODIFY_QUICKBUY_ITEM: 'MODIFY_QUICKBUY_ITEM',
  REMOVE_QUICKBUY_ITEM: 'REMOVE_QUICKBUY_ITEM',
  REMOVE_QUICKBUY_ALL_ITEMS: 'REMOVE_QUICKBUY_ALL_ITEMS',
  ADD_SNSEARCH_RESULT: 'ADD_SNSEARCH_RESULT',
}
